import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers'
import { Box, Grid, FormHelperText } from '@mui/material'

import { StateSchema } from '@/hooks/form/models'
import { setTimeForToday } from '@/utils/date'

type Props = {
  state: StateSchema
  handleOnChange: (name: string, value: any) => void
}

const DailyPeriodComponent = ({ state, handleOnChange }: Props) => {
  const { t } = useTranslation()

  const [fullStartDate, setFullStartDate] = useState(
    setTimeForToday(state.startTime.value),
  )

  const [fullEndDate, setFullEndDate] = useState(
    setTimeForToday(state.endTime.value),
  )

  const handleChangeStartTime = (time: string) => {
    const date = new Date(time)
    const timeDate = `${date.getHours()}:${date.getMinutes()}:00`
    handleOnChange('startTime', timeDate)
    if (date.toString() !== 'Invalid Date') {
      setFullStartDate(date)
    }
  }

  const handleChangeEndTime = (time: string) => {
    const date = new Date(time)
    handleOnChange('endTime', `${date.getHours()}:${date.getMinutes()}:00`)
    if (date.toString() !== 'Invalid Date') {
      setFullEndDate(date)
    }
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box my={2} mb={1} maxWidth={400}>
        <Grid container spacing={2}>
          <Grid item xs={12} lg={6}>
            <Box mt={1}>
              <TimePicker
                views={['hours', 'minutes']}
                label={t('labels.startTime')}
                value={dayjs(setTimeForToday(state.startTime.value))}
                onChange={(date) => handleChangeStartTime(date.toString())}
              />
            </Box>
            {fullStartDate > fullEndDate && (
              <FormHelperText error={fullStartDate > fullEndDate}>
                {t('messages.validateEndTime')}
              </FormHelperText>
            )}
          </Grid>
          <Grid item xs={12} lg={6}>
            <Box mt={1}>
              <TimePicker
                views={['hours', 'minutes']}
                label={t('labels.endTime')}
                value={dayjs(setTimeForToday(state.endTime.value))}
                onChange={(date) => handleChangeEndTime(date.toString())}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </LocalizationProvider>
  )
}

export default DailyPeriodComponent
